"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Iterator_1 = __importDefault(require("../Maker/Iterator"));
const exception_1 = require("@almservices-cl/exception");
const arrayMaker_1 = __importDefault(require("../../../Util/arrayMaker"));
class NutritionMaker {
    constructor() {
        this.productsIterator = new Iterator_1.default([
            {
                name: "Croissant",
                nutritionFacts: {
                    calories: 182,
                    carbs: 19.04,
                    fats: 9.5,
                    fibers: 1.13,
                    protein: 4.32,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Ei rauw",
                nutritionFacts: {
                    calories: 73,
                    carbs: 0.11,
                    fats: 5.01,
                    fibers: 0,
                    protein: 6.77,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Linzen Rood gedroogd",
                nutritionFacts: {
                    calories: 618,
                    carbs: 89,
                    fats: 3,
                    fibers: 31.6,
                    protein: 42,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Tomaat rauw",
                nutritionFacts: {
                    calories: 28,
                    carbs: 4.06,
                    fats: 0.56,
                    fibers: 1.82,
                    protein: 0.98,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Sjalot/ui",
                nutritionFacts: {
                    calories: 19,
                    carbs: 4.38,
                    fats: 0.12,
                    fibers: 1.56,
                    protein: 1.08,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Aardappelen (rauw)",
                nutritionFacts: {
                    calories: 88,
                    carbs: 19,
                    fats: 0,
                    fibers: 1.8,
                    protein: 2,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Paprikapoeder",
                nutritionFacts: {
                    calories: 18,
                    carbs: 1.75,
                    fats: 0.65,
                    fibers: 1.05,
                    protein: 0.75,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "Olie of vloeibare boter",
                nutritionFacts: {
                    calories: 88,
                    carbs: 0,
                    fats: 10,
                    fibers: 0,
                    protein: 0,
                },
                measure: {
                    value: 250,
                },
            },
            {
                name: "2 teentjes knoflook vers",
                nutritionFacts: {
                    calories: 3,
                    carbs: 0.56,
                    fats: 0,
                    fibers: 0.02,
                    protein: 0.12,
                },
                measure: {
                    value: 250,
                },
            },
        ]);
        this.nutrientsAmountIterator = new Iterator_1.default([3, 6, 2, 6]);
        this.isMealPlanIterator = new Iterator_1.default([false, false, true]);
        this.mealNamesIterator = new Iterator_1.default([
            "Pizza Quinoa Overschotel",
            "Vegetarishe lasagne",
            "Snelle wrap met kip",
            "Lizensoep",
            "Turkse pizza met kip",
            "Pindakaas Koekjes",
            "Phad thai salade",
            "Personal Protein gepofte rijst treats",
        ]);
        this.mealDescriptionIterator = new Iterator_1.default([
            "bloem\n" +
                "water (lauwwarm)\n" +
                "verse gist of 10 gram gedroogde gist\n" +
                "3 eetlepels olijfolie\n" +
                "3 theelepels zout (fijn zout, zonder bergje)\n" +
                "1 theelepel suiker",
            "400-500 g pipe rigate ( pasta ) of tagliatelle of spaghetti.\n" +
                "3 kipfilets\n" +
                "olijfolie\n" +
                "1 pak spinazie á la crème ( à 500 gr/ diepvries )\n" +
                "1 pakje Boursin roomkaas Ail & Fines Herbes 150 gr ( of boursin cuisinne ).\n" +
                "1 bakje kastanje champignons\n" +
                "50 gr pijnboompitten, licht geroosterd\n" +
                "6 - 7 zongedroogde tomaten.\n" +
                "peper & zout naar smaak\n" +
                "eventueel extra knoflook/ui en pepers naar smaak !!",
            "1 zak nacho cheese tortilla chips\n" +
                "300 gr. rundergehakt\n" +
                "1 zakje taco kruiden\n" +
                "1 (punt) paprika\n" +
                "1 ui\n" +
                "2 teentjes knoflook\n" +
                "cheddar cheese\n" +
                "geraspte kaas",
            "750 gram riblappen - 750 gram uien - zout, peper - 3 kruidnagelen - 1 laurierblad (of 1 blad daon salam )- 2 rode Spaanse pepers - 1/2 dl ketjap manis - 4 teentjes knoflook - 3 eetlepels olie - 1 theelepel ketoembar ( koriander ) - 1 afgestreken eetlepel kerriepoeder - 2 eetlepels azijn - 1 eetlepel donkerbruine basterdsuiker - 1 eetlepel bloem - 1 vleesbouillontablet\n",
        ]);
        this.timeIterator = new Iterator_1.default([
            "07:30",
            "12:00",
            "15:00",
            "20:00",
        ]);
        this.imageIterator = new Iterator_1.default([
            {
                thumbnail: "https://media.gettyimages.com/photos/authentic-indian-food-picture-id639389404?s=612x612",
            },
            {
                thumbnail: "https://bluewater.co.uk/sites/bluewater/files/styles/image_spotlight_large/public/images/spotlights/burger-cropped.jpg?itok=SeFYMFP6",
            },
            {
                thumbnail: "https://www.bbcgoodfood.com/sites/default/files/recipe-collections/collection-image/2013/05/buffalo-wings.jpg",
            },
            null,
            {
                thumbnail: "https://amp.insider.com/images/5ad792ffbd967146008b45d9-750-562.jpg",
            },
            null,
            null,
        ]);
        this.createDay = (method, date, // yyyy-MM-dd
        mealsNum, dayType, calorieBudgetFill) => {
            const meals = (0, arrayMaker_1.default)(mealsNum, (index) => {
                let mealMethod = method;
                if (mealMethod === "mixed") {
                    mealMethod = index % 2 ? "caloriecount" : "handpalm";
                }
                return this.createMeal(mealMethod);
            });
            const dayTemplate = {
                method,
                date,
                meals,
                dayType,
                calorieBudgetInfo: null,
            };
            if (method === "handpalm") {
                return dayTemplate;
            }
            if (calorieBudgetFill === undefined) {
                throw new exception_1.BadMethodCallException("Calorie Budget fill is missing, but is required for caloriecount/mixed method");
            }
            const totalNutritionFacts = this.sumMealNutritionFacts(meals.filter((meal) => meal.method === "caloriecount"));
            const calorieBudget = {
                calories: parseInt((totalNutritionFacts.calories * calorieBudgetFill).toString()),
                carbs: totalNutritionFacts.carbs * calorieBudgetFill,
                fats: totalNutritionFacts.fats * calorieBudgetFill,
                fibers: totalNutritionFacts.fibers * calorieBudgetFill,
                protein: totalNutritionFacts.protein * calorieBudgetFill,
            };
            return {
                ...dayTemplate,
                calorieBudget,
                nutritionFacts: totalNutritionFacts,
            };
        };
        this.createMeal = (method) => {
            switch (method) {
                case "handpalm":
                    return this.createHandpalmMeal();
                case "caloriecount":
                    return this.createCalorieCountMeal();
            }
        };
        this.sumMealNutritionFacts = (items) => {
            const nutritionFacts = {
                calories: 0,
                carbs: 0.0,
                fats: 0.0,
                fibers: 0.0,
                protein: 0.0,
            };
            items.forEach((item) => {
                nutritionFacts.calories += item.nutritionFacts.calories;
                nutritionFacts.carbs += item.nutritionFacts.carbs;
                nutritionFacts.fats += item.nutritionFacts.fats;
                nutritionFacts.fibers += item.nutritionFacts.fibers;
                nutritionFacts.protein += item.nutritionFacts.protein;
            });
            const fractionDigits = 2;
            nutritionFacts.calories = parseFloat(nutritionFacts.calories.toFixed(fractionDigits));
            nutritionFacts.carbs = parseFloat(nutritionFacts.carbs.toFixed(fractionDigits));
            nutritionFacts.fats = parseFloat(nutritionFacts.fats.toFixed(fractionDigits));
            nutritionFacts.fibers = parseFloat(nutritionFacts.fibers.toFixed(fractionDigits));
            nutritionFacts.protein = parseFloat(nutritionFacts.protein.toFixed(fractionDigits));
            return nutritionFacts;
        };
    }
    createHandpalmMeal() {
        return {
            method: "handpalm",
            name: this.mealNamesIterator.next(),
            time: this.timeIterator.next(),
            description: this.mealDescriptionIterator.next(),
            image: this.imageIterator.next(),
        };
    }
    createCalorieCountMeal() {
        const nutrients = [];
        const nAmount = this.nutrientsAmountIterator.next();
        for (let n = 0; n < nAmount; n++) {
            nutrients.push(this.productsIterator.next());
        }
        return {
            method: "caloriecount",
            name: this.mealNamesIterator.next(),
            nutrients,
            nutritionFacts: this.sumMealNutritionFacts(nutrients),
            image: this.imageIterator.next(),
            isMealPlan: this.isMealPlanIterator.next(),
        };
    }
}
exports.default = NutritionMaker;
//# sourceMappingURL=NutritionMaker.js.map